import { TransferStationProxy } from '../../proxy/transferStation/transferStation.proxy';
import { Injectable } from '@angular/core';

@Injectable()
export class TransferStationService {
  constructor(private proxy: TransferStationProxy) {}
  getDisclaimers() {
    return this.proxy.getDisclaimers();
  }

  acceptDisclaimer(code: string) {
    return this.proxy.acceptDisclaimer(code);
  }

  declineDisclaimer(code: string) {
    return this.proxy.declineDisclaimer(code);
  }
}
